import React, { Component } from 'react';

import PropertyFAQ from 'components/tenant_app/components/building/PropertyFAQs';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import { List } from 'material-ui/List';
import Subheader from 'material-ui/Subheader';
import { MdInfoOutline as InfoIcon } from 'react-icons/md';

import { AccentColor } from 'helpers/AccentColorHelper';

class BuildingDetails extends Component {
  render() {
    const style = {
      card: {
        color: '#424242 !important',
        fontFamily: '"Circular", sans-serif !important',
        height: '100%',
        overflow: 'auto',
      },
      card_header: {
        backgroundColor: '#fff',
        borderBottom: '1px solid #e0e0e0',
        padding: '11px 16px',
        fontFamily: 'Circular-Bold',
        backgroundImage: `-webkit-linear-gradient(left, ${AccentColor()}d6, ${AccentColor()}d6 49px, transparent 49px, transparent 100%)`,
        width: '100%',
      },
      card_text: {
        padding: '15px 8px 0 8px',
        fontFamily: '"Circular", sans-serif !important',
      },
      subheader: {
        lineHeight: 0,
        padding: '20px 16px 10px 16px',
      },
      subheader_item: {
        margin: 0,
        fontSize: '15px',
      },
      subheader_side_padding: {
        padding: '0 16px',
      },
      no_padding: {
        padding: 0,
      },
    };

    const building = this.props.building;
    return (
      <div className="grid-column">
        <Card style={style.card} className="card" initiallyExpanded={true}>
          <CardHeader
            id="card-header"
            style={style.card_header}
            title={
              <span>
                <InfoIcon
                  size={18}
                  style={{ verticalAlign: 'middle', marginRight: '26px', color: 'white' }}
                />
                &nbsp;Building Details
                <span>
                  <PropertyFAQ />
                </span>
              </span>
            }
            actAsExpander={false}
            showExpandableButton={false}
          />
          <CardText expandable={true} style={style.card_text}>
            <List style={style.no_padding}>
              <div className="col-xs-12" style={style.no_padding}>
                <Subheader inset={false} style={style.subheader}>
                  Property
                </Subheader>
                <div style={style.subheader_side_padding}>
                  <p style={style.subheader_item}>{building && building.name}</p>
                </div>
              </div>

              <div className="col-xs-12" style={style.no_padding}>
                <Subheader inset={false} style={style.subheader}>
                  Street
                </Subheader>
                <div style={style.subheader_side_padding}>
                  <p style={style.subheader_item}>{building && building.address.street}</p>
                </div>
              </div>

              <div className="col-xs-6" style={style.no_padding}>
                <Subheader inset={false} style={style.subheader}>
                  City
                </Subheader>
                <div style={style.subheader_side_padding}>
                  <p style={style.subheader_item}>{building && building.address.city}</p>
                </div>
              </div>

              <div className="col-xs-6" style={style.no_padding}>
                <Subheader inset={false} style={style.subheader}>
                  Province
                </Subheader>
                <div style={style.subheader_side_padding}>
                  <p style={style.subheader_item}>{building && building.address.province}</p>
                </div>
              </div>

              <div className="col-xs-6" style={style.no_padding}>
                <Subheader inset={false} style={style.subheader}>
                  Postal Code
                </Subheader>
                <div style={style.subheader_side_padding}>
                  <p style={style.subheader_item}>{building && building.address.postal_code}</p>
                </div>
              </div>

              <div className="col-xs-6" style={style.no_padding}>
                <Subheader inset={false} style={style.subheader}>
                  Country
                </Subheader>
                <div style={style.subheader_side_padding}>
                  <p style={style.subheader_item}>{building && building.address.country}</p>
                </div>
              </div>
            </List>
          </CardText>
        </Card>
      </div>
    );
  }
}

export default BuildingDetails;
